const SUPPORTED_COMPETITIONS = {
  39: 39, // legacy support for id based access
  premierleague: 39,
  ligue1: 61,
  seriea: 135,
  laliga: 140,
  bundesliga: 78,
  afcon: 6,
};

export default SUPPORTED_COMPETITIONS;
